import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner-native";

import { HouseholdUpdateType } from "@/domain/household";

import "@/domain/householdMember";

import { useTranslator } from "@/hooks/useTranslate";
import { queryClient } from "@/utils/queryClient";

import { HouseholdsApi } from "../api/householdsApi";
import { HouseholdsQueryKeys } from "../queries/householdsQueries";

export const useUpdateHouseholdMutation = () => {
  const { t } = useTranslator();

  return useMutation({
    mutationFn: async ({
      id,
      householdData,
    }: {
      id: string;
      householdData: HouseholdUpdateType;
    }) => HouseholdsApi.updateHousehold(id, householdData),
    onError: () => {
      toast.error(t("native:eligibilityHouseholdIncomeScreen.updateError"));
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: HouseholdsQueryKeys.mineHousehold(),
      });
    },
  });
};
